import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUIListSubheader(theme: Theme): Components['MuiListSubheader'] {
  return {
    styleOverrides: {
      root: {
        ...theme.typography.subtitle1,
      },
    },
  };
}
